import React from 'react';
import { Outlet } from "react-router-dom";
import HeaderComponent from "./header/Header";
import FooterComponent from "./footer";

export const AppLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen font-poppins bg-gray-50 space-y-0">
      {/* Header */}
      <HeaderComponent />

      {/* Main content */}
      <main className="w-full max-h-fit m-0 min-h-screen overflow-hidden">
        <Outlet />
      </main>

      {/* Footer */}
      <FooterComponent />
    </div>
  );
};

export default AppLayout;
